export const LOYALTY_LEVEL_TITLES = ['Bronze', 'Silver', 'Gold', 'Elite'];
export const LOYALTY_LEVEL_OPTIONS = LOYALTY_LEVEL_TITLES.map(
  (label, value) => ({
    value,
    label,
  }),
);
